import ContentContainer from '@components/ContentContainer';
import SourcesTable from '@components/tables/SourcesTable';
import { useBreadcrumbs, useTeamId } from '@utils/router';

const LibrarySourcesPage = () => {
  const teamId = useTeamId();
  const breadcrumbs = useBreadcrumbs();

  if (!teamId) return <ContentContainer.Loading />;
  return (
    <ContentContainer>
      <ContentContainer.Header title="Sources" breadcrumbs={breadcrumbs} />
      <SourcesTable />
    </ContentContainer>
  );
};

export default LibrarySourcesPage;
